import { createAction } from 'redux-actions';

export const WORKSPACE_PRODUCER_ID_SET = 'WORKSPACE_PRODUCER_ID_SET';

export default createAction(WORKSPACE_PRODUCER_ID_SET);
